import { Statistic } from 'antd';
import { createElement } from 'react';
import './index.less';
const DataVStatistic = (props) => {
    const { title, titleStyle, ...rest } = props;
    const _title = (createElement("span", { style: titleStyle }, title));
    return (createElement(Statistic, { className: "datav-statistic", ...rest, title: _title }));
};
export default DataVStatistic;
